import { Mail, Phone, ArrowUp } from "lucide-react";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { navigation, siteConfig } from "../data/siteData.js";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-top">
        <div className="footer-brand-column">
          <a className="brand" href="#top" aria-label="Ugrás az oldal tetejére">
            <span className="brand-mark">{siteConfig.shortBrand}</span>
            <span className="brand-copy">
              <strong>MARTIN</strong>
              <small>COACHING</small>
            </span>
          </a>

          <p>
            Személyi edzés Székesfehérváron és online coaching az ország
            bármely pontjáról.
          </p>

          <div className="footer-socials">
            <a
              href={siteConfig.contact.instagram}
              aria-label="Instagram"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram size={19} />
            </a>

            <a
              href={siteConfig.contact.facebook}
              aria-label="Facebook"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF size={19} />
            </a>

            <a
              href={`mailto:${siteConfig.contact.email}`}
              aria-label="E-mail"
            >
              <Mail size={19} />
            </a>

            <a
              href={`tel:${siteConfig.contact.phone}`}
              aria-label="Telefon"
            >
              <Phone size={19} />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h3>Oldalak</h3>

          {navigation.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </div>

        <div className="footer-column">
          <h3>Szolgáltatások</h3>

          <a href="#szolgaltatasok">Személyi edzés</a>
          <a href="#szolgaltatasok">Online coaching</a>
          <a href="#szolgaltatasok">Edzésterv</a>
          <a href="#szolgaltatasok">Táplálkozási terv</a>
        </div>

        <div className="footer-column footer-newsletter">
          <h3>Ingyenes tippek</h3>

          <p>
            Később ide köthető egy ingyenes PDF vagy heti szakmai hírlevél.
          </p>

          <form onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="E-mail címed"
              aria-label="E-mail cím"
            />

            <button type="submit">→</button>
          </form>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>
          © {new Date().getFullYear()} Martin Coaching. Minden jog fenntartva.
        </p>

        <div>
          <a href="#top">Adatkezelés</a>
          <a href="#top">ÁSZF</a>
          <a href="#top">Impresszum</a>
        </div>

        <a
          className="back-to-top"
          href="#top"
          aria-label="Vissza az oldal tetejére"
        >
          <ArrowUp size={18} />
        </a>
      </div>
    </footer>
  );
}